/*
This component is based on the CacheBuster component from this example https://github.com/flexdinesh/cache-busting-example
*/

import React, { useEffect, useState } from 'react';

import packageJson from '../../../package.json';

declare global {
  var appVersion: string;
}
global.appVersion = packageJson.version;

const semverGreaterThan = (versionA: string, versionB: string) => {
  const versionAComponents = versionA.split(/\./g);
  const versionBComponents = versionB.split(/\./g);

  while (versionAComponents.length || versionBComponents.length) {
    const a = Number(versionAComponents.shift());
    const b = Number(versionBComponents.shift());

    if (a === b) continue;
    return a > b || isNaN(b);
  }
  return false;
};

const refreshCacheAndReload = () => {
  // console.log('Clearing cache and hard reloading...');
  if (caches) {
    caches.keys().then((names) => {
      names.forEach((name) => caches.delete(name));
    });
  }

  window.location.reload();
};

interface Props {}

export const CacheBuster: React.FC<Props> = (props) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    fetch('meta.json')
      .then((res) => res.json())
      .then((meta) => {
        const latestVersion = meta.version;
        const currentVersion = global.appVersion;

        const shouldForceRefresh = semverGreaterThan(
          latestVersion,
          currentVersion
        );
        if (shouldForceRefresh) {
          // console.log(
          //   `We have a new version - ${latestVersion}. Should force refresh`
          // );
          setIsLoading(false);
          refreshCacheAndReload();
        } else {
          // console.log(
          //   `You already have the latest version - ${latestVersion}. No cache refresh needed`
          // );
          setIsLoading(false);
        }
      });
  }, []);

  return <>{!isLoading && props.children}</>;
};
